import Content from "../Content";

const DesktopSidebar = () => {
  return (
    <div className="tw:hidden tw:lg:block tw:fixed tw:h-svh tw:z-[1400] tw:shadow-[6px_0px_3px_-3px_#DEE4EB]">
      <Content />
    </div>
  );
};

export default DesktopSidebar;
